/**
 * Realm aliases of the Keycloak brokers, as emitted in `identity_provider`. They must
 * match the terraform `onelogin_seb_link_idp_alias` variable and `google_idp_alias`
 * local; a rename on one side only makes every such login read as an email login.
 */
export const KEYCLOAK_IDP_ALIAS = {
  mitid: 'dkseb',
  google: 'google-ws-melatech',
} as const;

/** Value the OneLogin fast path stamps into `auth_method`. */
export const KEYCLOAK_ONELOGIN_AUTH_METHOD = '1login';

// Header name containing device id
export const DeviceIdHeaderName = 'x-device-id';

// Header name containing session token
export const KratosSessionHeaderName = 'x-session-token';

// Header name containing session device token
export const DeviceSessionHeaderName = 'x-device-session-token';

// Header name containing jurisdictional groups locale
export const LocaleHeaderName = 'locale';

// Header name containing accept-language header
export const AcceptLanguageHeaderName = 'accept-language';

// Header name containing FHIR encounter reference from Epic launch context
export const EncounterReferenceHeaderName = 'x-encounter-reference';

// Header name containing FHIR location reference resolved from Epic launch context
export const LocationReferenceHeaderName = 'x-location-reference';

// Valid FHIR location reference format: Location/<id>
export const LocationReferencePattern = /^Location\/[A-Za-z0-9\-._]+$/;

/**
 * What redeeming an email OTP authorises. One mechanism (6 digits, hashed, TTL,
 * attempt limit), three different authorities — so a code minted for one flow
 * must never be redeemable in another, and minting for one flow must not
 * invalidate another's outstanding code.
 */
export enum EmailOtpPurpose {
  /** Passwordless login: proves mailbox control to authenticate. */
  Login = 'login',
  /** Forgot-password: proves mailbox control to set a new password. */
  Recovery = 'recovery',
  /** Authenticated profile-email check: proves the mailbox belongs to the user. */
  EmailVerification = 'email_verification',
}

/** How long a login/recovery email OTP stays redeemable — the email states it too. */
export const LoginOtpTtlMinutes = 15;

export const authenticationScreens = [
  'none',
  'register',
  'recovery',
  'change-password',
  'app',
] as const;
export type AuthenticationScreenType = (typeof authenticationScreens)[number];
